(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitalaxis-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-va-landing]'); if (!root || root.dataset.ready === '1') return; root.dataset.ready = '1';
  // Gallery
  const main = root.querySelector('[data-va-main-image]'), thumbs = [...root.querySelectorAll('[data-va-thumb]')], prev = root.querySelector('[data-va-prev]'), next = root.querySelector('[data-va-next]');
  let index = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
  const show = (i, smooth = true) => { if (!main || !thumbs.length) return; index = (i + thumbs.length) % thumbs.length; const t = thumbs[index]; main.src = t.dataset.image; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || ''; thumbs.forEach((x, n) => { x.classList.toggle('is-active', n === index); x.setAttribute('aria-current', n === index ? 'true' : 'false'); }); t.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'nearest', inline: 'center' }); };
  thumbs.forEach((t, i) => t.addEventListener('click', e => { e.preventDefault(); show(i); }));
  if (prev) prev.addEventListener('click', () => show(index - 1));
  if (next) next.addEventListener('click', () => show(index + 1));
  const gallery = root.querySelector('[data-va-gallery]'); let sx = null, sy = null;
  if (gallery) { gallery.addEventListener('touchstart', e => { sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY; }, { passive: true }); gallery.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = sy = null; if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1)); }, { passive: true }); }
  // Price displays
  const priceEl = root.querySelector('[data-va-price]'), stickyPriceEl = root.querySelector('[data-va-sticky-price]');
  const setPrice = (money) => { if (priceEl && money) priceEl.textContent = money; if (stickyPriceEl && money) stickyPriceEl.textContent = money; };
  const variantSelect = root.querySelector('[data-va-variant-select]');
  const qtyPriceSpans = [...root.querySelectorAll('[data-va-qty-price]')];
  const updateQtyPrices = () => {
    if (!variantSelect || !qtyPriceSpans.length) return;
    const opt = variantSelect.selectedOptions[0];
    const cents = opt ? parseInt(opt.dataset.cents || '0', 10) : 0;
    if (!cents || !priceEl) return;
    const sym = (priceEl.textContent.match(/[^0-9.,\s]/) || ['$'])[0];
    qtyPriceSpans.forEach(sp => {
      const qn = parseInt(sp.dataset.vaQtyPrice || '1', 10);
      sp.textContent = sym + (cents * qn / 100).toFixed(2);
    });
  };
  if (variantSelect) variantSelect.addEventListener('change', () => { const opt = variantSelect.selectedOptions[0]; if (opt && opt.dataset.money) setPrice(opt.dataset.money); updateQtyPrices(); });
  // Quantity + bundle (quantity mode)
  const q = root.querySelector('[data-va-qty]'), minus = root.querySelector('[data-qty-minus]'), plus = root.querySelector('[data-qty-plus]');
  if (q && minus && plus) { minus.addEventListener('click', () => { q.value = Math.max(1, (+q.value || 1) - 1); q.dispatchEvent(new Event('input', { bubbles: true })); }); plus.addEventListener('click', () => { q.value = Math.min(20, (+q.value || 1) + 1); q.dispatchEvent(new Event('input', { bubbles: true })); }); }
  const qtyOptions = [...root.querySelectorAll('[data-va-bundle-option]')];
  if (qtyOptions.length && q) { const syncBundle = (value) => { const n = Math.max(1, Math.min(20, Number(value) || 1)); q.value = n; qtyOptions.forEach(btn => { const selected = Number(btn.dataset.vaBundleOption) === n; btn.classList.toggle('is-selected', selected); btn.setAttribute('aria-pressed', selected ? 'true' : 'false'); }); }; qtyOptions.forEach(btn => btn.addEventListener('click', () => syncBundle(btn.dataset.vaBundleOption))); q.addEventListener('input', () => { const n = Number(q.value) || 1; qtyOptions.forEach(btn => { const selected = Number(btn.dataset.vaBundleOption) === n; btn.classList.toggle('is-selected', selected); btn.setAttribute('aria-pressed', selected ? 'true' : 'false'); }); }); }
  // Bundle (pack-variant mode): priced tiers select the Pack variant
  const packOptions = [...root.querySelectorAll('[data-va-pack]')];
  if (packOptions.length && variantSelect) {
    packOptions.forEach(btn => btn.addEventListener('click', () => {
      const id = btn.dataset.variantId;
      const opt = [...variantSelect.options].find(o => o.value === id);
      if (opt) { variantSelect.value = id; }
      if (q) q.value = 1;
      if (btn.dataset.money) setPrice(btn.dataset.money);
      packOptions.forEach(b => { const s = b === btn; b.classList.toggle('is-selected', s); b.setAttribute('aria-pressed', s ? 'true' : 'false'); });
    }));
  }
  // Before / after slider
  const ba = root.querySelector('[data-va-ba]');
  if (ba) {
    const before = ba.querySelector('[data-va-ba-before]'), handle = ba.querySelector('[data-va-ba-handle]');
    const setPos = (clientX) => { const r = ba.getBoundingClientRect(); let p = (clientX - r.left) / r.width; p = Math.max(0.02, Math.min(0.98, p)); before.style.width = (p * 100) + '%'; handle.style.left = (p * 100) + '%'; };
    let dragging = false;
    handle.addEventListener('pointerdown', e => { dragging = true; handle.setPointerCapture(e.pointerId); e.preventDefault(); });
    handle.addEventListener('pointermove', e => { if (dragging) setPos(e.clientX); });
    handle.addEventListener('pointerup', () => { dragging = false; });
    handle.addEventListener('pointercancel', () => { dragging = false; });
    ba.addEventListener('pointerdown', e => { if (e.target.closest('[data-va-ba-handle]')) return; setPos(e.clientX); });
    handle.addEventListener('keydown', e => { const cur = parseFloat(before.style.width) || 50; if (e.key === 'ArrowLeft') { before.style.width = Math.max(2, cur - 5) + '%'; handle.style.left = before.style.width; } if (e.key === 'ArrowRight') { before.style.width = Math.min(98, cur + 5) + '%'; handle.style.left = before.style.width; } });
    handle.tabIndex = 0;
  }
  // Delivery date (+5 days)
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const d = new Date(); d.setDate(d.getDate() + 5);
  const label = days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
  const shortLabel = days[d.getDay()].slice(0, 3) + ', ' + d.getDate() + ' ' + months[d.getMonth()].slice(0, 3);
  root.querySelectorAll('[data-va-delivery]').forEach(el => { el.textContent = 'Order today and get it by ' + label; });
  root.querySelectorAll('[data-va-delivery-short]').forEach(el => { el.textContent = shortLabel; });
  const owEls = root.querySelectorAll('[data-va-orderwithin]');
  const tickOw = () => { const now = new Date(); const end = new Date(now); end.setHours(24, 0, 0, 0); const s = Math.max(0, Math.floor((end - now) / 1000)); owEls.forEach(el => { el.textContent = Math.floor(s / 3600) + ' hours ' + String(Math.floor(s % 3600 / 60)).padStart(2, '0') + ' minutes'; }); };
  if (owEls.length) { tickOw(); setInterval(tickOw, 30000); }
})();

  } catch(e) { console.error(e); }
})();
})();
